import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

const ReinvestProgressCard = ({
  totalAmount = 0,
  threshold = 1000,
  investmentID,
}) => {
  const [canReinvest, setCanReinvest] = useState(false);
  const [progress, setProgress] = useState(0);
  const [remaining, setRemaining] = useState(threshold);
  const cardCurrencyName = useSelector((state) => state.user.cardCurrencyName);

  useEffect(() => {
    const computedProgress = Math.min((totalAmount / threshold) * 100, 100);
    const remainingAmount = Math.max(threshold - totalAmount, 0);

    setProgress(computedProgress);
    setRemaining(remainingAmount);
    setCanReinvest(totalAmount >= threshold);
  }, [totalAmount, threshold]);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-2 md:gap-4 font-semibold mt-4 text-sm">
      <div className="bg-[#3047EC] bg-opacity-20 px-4 py-4 rounded-lg flex flex-col justify-between h-full w-full">
        {/* Info & Button */}
        <div className="flex justify-between items-center mb-4">
          <div className="flex flex-col space-y-1">
            <span className="text-sm font-semibold text-[#1A1A1A]">
              Total Dividend
            </span>
            <span className="text-[#3047EC] text-sm font-semibold">
              {cardCurrencyName.symbol}
              {totalAmount
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            </span>
          </div>

          {investmentID != -1 && (
            <button
              className={`text-xs px-3 py-1 rounded-full self-center transition-all duration-200 ${
                canReinvest
                  ? "bg-black text-white hover:bg-gray-900"
                  : "bg-gray-300 text-gray-600 cursor-not-allowed"
              }`}
              disabled={!canReinvest}
              onClick={() => {
                if (canReinvest) {
                  // Your reinvest logic here
                  alert("Reinvesting...");
                }
              }}
            >
              Re-invest Now
            </button>
          )}
        </div>

        {/* Progress Bar */}
        {investmentID != -1 && (
          <div className="w-full space-y-1">
            {/* Labels */}
            <div className="flex justify-between items-center text-[11px] font-medium text-gray-700 dark:text-gray-300">
              <span>Progress to Reinvest</span>
              <span>{`${Math.min(progress, 100).toFixed(0)}%`}</span>
            </div>

            {/* Track */}
            <div className="relative w-full h-4 rounded-full bg-gray-200 dark:bg-gray-800 overflow-hidden shadow-sm">
              {/* Fill */}
              <div
                className="absolute top-0 left-0 h-full bg-gradient-to-r from-[#4A6CF7] to-[#3047EC] transition-all duration-500 ease-out"
                style={{ width: `${Math.min(progress, 100)}%` }}
              ></div>
            </div>

            {/* Remaining info */}
            <div className="text-[10px] text-gray-500 dark:text-gray-400">
              {canReinvest ? (
                <span className="text-green-600 font-semibold">
                  You are now eligible to reinvest.
                </span>
              ) : (
                <span>
                  {cardCurrencyName.symbol}
                  {remaining
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                  remaining to reach threshold
                </span>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReinvestProgressCard;
